import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconRuler32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconRuler32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M9 16V5h5v3h-2a1 1 0 1 0 0 2h2v2h-2a1 1 0 1 0 0 2h2v2zm-2 0V5a2 2 0 0 1 2-2h5a2 2 0 0 1 2 2v11h11a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H16v2a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2v-2H5a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2zm2 9h5v2H9zm18-2H5v-5h2v2a1 1 0 1 0 2 0v-2h2v2a1 1 0 1 0 2 0v-2h2v2a1 1 0 1 0 2 0v-2h2v2a1 1 0 1 0 2 0v-2h2v2a1 1 0 1 0 2 0v-2h2z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconRuler32);
